import { CurrencyDisplay, StatusChip } from "components";
import moment from "moment";
import { formatDate, textCapitalization } from "utils";

export const optionsStatusAdvanceComposer = [
  {
    name: "Open",
    value: "open",
    color: "success",
  },
  {
    name: "Closed",
    value: "closed",
    color: "danger",
  },
];

export const columnTable = [
  {
    name: "composer_name",
    title: "Composer/Author Name",
  },
  {
    name: "date",
    title: "Date",
    renderText: date => (date ? formatDate(moment(date, "YYYY-MM-DD")) : "-"),
  },
  {
    name: "contract_number",
    title: "Contract Number",
    renderText: item => item || "-",
  },
  {
    name: "cost_allocation_period",
    title: "Cost Allocation Period",
    renderText: item => item || "-",
  },
  {
    name: "cost_allocation_amount",
    title: "Cost Allocation Amount",
    headerAlign: "right",
    renderText: cost_allocation_amount => (
      <CurrencyDisplay
        value={cost_allocation_amount}
        decimalScale={2}
        prefix="Rp"
      />
    ),
  },
  {
    name: "paid_amount",
    title: "Paid Amount",
    headerAlign: "right",
    renderText: paid_amount => (
      <CurrencyDisplay value={paid_amount} decimalScale={2} prefix="Rp" />
    ),
  },
  {
    name: "unpaid_amount",
    title: "Unpaid Amount",
    headerAlign: "right",
    renderText: unpaid_amount => (
      <CurrencyDisplay value={unpaid_amount} decimalScale={2} prefix="Rp" />
    ),
  },
  {
    name: "status",
    title: "Status",
    renderText: status => (
      <StatusChip
        label={textCapitalization(status)}
        type={status === "open" ? "success" : status === "closed" ? "danger" : "default"}
      />
    ),
  },
];

export const summaryAttributes = [
  { key: "settled", tooltip_title: "Settled" },
  { key: "total", tooltip_title: "Total" },
  { key: "unsettled", tooltip_title: "Unsettled" },
];
